import { Outlet } from 'react-router-dom'
import React from 'react'

const ReviewLayout = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default ReviewLayout
